var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-bing-container",on:{"click":_vm.handleClick}},[_c('img',{staticStyle:{"width":"36px","height":"36px"},attrs:{"src":require("@/assets/icon/icon-search.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }